export default {
  title: 'Линия жизни',
  details: 'ещё',
  stageInfo: 'ВЫ НА \n{num} ЭТАПЕ',
  thumbUp: '👍',
  plates: {
    flatBooked: {
      title: 'Ваша будущая квартира',
      annotation: '{roomsAmount}-к квартира {areaTotal}м²'
    },
    type_of_ownership: {
      title: 'Выбор типа собственности и формы оплаты',
      stepName: 'Выбор формы \nоплаты',
      annotation: 'Нам понадобится перечень документов, сформированный исходя из формы оплаты',
      desc: 'Нам понадобится перечень документов, сформированный исходя из формы оплаты (один или несколько вариантов): \n' +
        '• Сертификат об одобрении ипотеки; \n' +
        '• Материнский сертификат + справка о состоянии финансовой части лицевого счёта лица, имеющего право на дополнительные меры государственной поддержки (указывается сумма МК); \n' +
        '• Военный сертификат; \n' +
        '• Жилищный сертификат; \n' +
        '• Заявление на рассрочку; \n' +
        '• Документы, исходя из семейного положения, необходимые для регистрации: нотариальное согласие супруга (необходимо при оформлении на одного из супругов по ДДУ либо при оформлении по Договору купли-продажи с использованием кредитных средств. При покупке по Договору купли продажи с 100% оплатой согласие не требуется), брачный договор (при наличии либо при оформлении в долевую собственность супругов); \n' +
        '• Документы при сделке с несовершеннолетними: свидетельство о рождении ребёнка либо паспорт, ИНН, СНИЛС. \n' +
        'В случае если за несовершеннолетнего действует законный представитель (опекун) необходимо представить постановление об опекунстве.'
    },
    docsCheck: {
      title: 'Проверка документов',
      annotation: 'Документы, исходя из выбранного способа оплаты и типа собственности, получены сотрудниками Ак Барс Дом',
      desc: 'Документы, исходя из выбранного способа оплаты и типа собственности, получены сотрудниками Ак Барс Дом. В течение 1 рабочего дня будет сформирован Договор на покупку квартиры. Если в ходе проверки документов данные с фото будут нечитабельными, консультант свяжется с вами дополнительно.'
    },
    agreement: {
      title: 'Согласование договора',
      stepName: 'Согласование \nдоговора',
      annotation: 'Перед подписанием договора ознакомьтесь с текстом договора и проверьте свои данные',
      desc: 'Перед подписанием договора ознакомьтесь с текстом договора и проверьте свои данные. \n' +
        'В случае покупки квартиры с использованием кредитных средств Договор также будет направлен в банк для внесения сотрудником данных по кредитному договору.'
    },
    signing_options: {
      title: 'Подписание договора',
      stepName: 'Подписание \nдоговора',
      annotation: 'После получения всех необходимых документов, в течение 1 рабочего дня, будет сформирован Договор на покупку квартиры',
      desc: 'После получения всех необходимых документов, в течение 1 рабочего дня, будет сформирован Договор на покупку квартиры. Перед подписанием вам будет направлен Договор для ознакомления и подтверждения корректности данных. В случае покупки квартиры с использованием кредитных средств Договор также будет направлен в банк для внесения сотрудником банка данных по кредитному договору.'
    },
    pay_state_duty: {
      title: 'Оплата \nгоспошлины',
      annotation: 'Перед тем, как зарегистрировать сделку в Росреестре, вам нужно оплатить госпошлину',
      desc: 'Перед тем, как зарегистрировать сделку в Росреестре, вам нужно оплатить госпошлину. Без оплаты госпошлины сделка не будет зарегистрирована.'
    },
    transaction: {
      title: 'Регистрация \nв Росреестре',
      annotation: 'После подачи всех необходимых документов происходит проверка на стороне Росреестра',
      desc: 'После подачи всех необходимых документов происходит проверка на стороне Росреестра. Сроки регистрации объектов предусмотрены законом №218-ФЗ «О государственной регистрации недвижимости». Обычно они составляют 7-9 дней, при электронной регистрации 3-5 дней.'
    },
    pay_under_contract: {
      title: 'Оплата по \nдоговору',
      annotation: 'Согласно ФЗ-№214 все сделки с недвижимостью на первичном рынке оплачиваются только в безналичной форме',
      desc: 'Согласно ФЗ-№214 все сделки с недвижимостью на первичном рынке оплачиваются только в безналичной форме. Оплата осуществляется после государственной регистрации договора в предусмотренный договором срок.'
    },
    final: {
      title: 'Успешная покупка',
      annotation: 'Поздравляем с покупкой квартиры!',
      stepName: '👍',
      desc: 'Поздравляем с покупкой квартиры! Каждый участник долевого строительства (дольщик) получает уведомление о старте заселения письмом на адрес регистрации, а также по номеру телефона, указанным в договоре. После получения уведомления записывается на осмотр помещения.'
    }
  },
  stateDutyModal: {
    title: 'Подтвердите \nоплату госпошлины',
    text: 'Без оплаты госпошлины в банке или на портале Госуслуг мы не сможем произвести регистрацию квартиры в Росреестре. Убедитесь, что сохранили квитанцию',
    confirm: 'Госпошлина оплачена',
    later: 'Подтвержу позже'
  }
}
